export const mobileNavComponent = {
  key: 'mobileNavComponent',
  name: 'Mobile Nav Dept-Component',
  siteIdentifier: 'global',

  petsafeLogoLabel: 'PetSafe logo. Click to go to homepage',
  openSearchLabel: 'Open Search',
  toggleNavigationMenuLabel: 'Toggle Navigation Menu',
};
